//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ActionList from './actionList';
import AddEvent from './addEvent';
export default {
  name: 'AdvanceConfigEndEvent',
  components: { ActionList, AddEvent },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      // 读取actions 分类生成事件列表
      actions: {
        ended: {
          pass: [],
          reject: [],
          rollback: [],
          revoke: [],
        },
      },
      // 高级设置中选中的一级与二级tab
      eventConfigOn: 'ended',
      eventConfigCondition: 'pass',
      // 用于存储高级设置编辑未保存时的临时数据
      eventConfigEditTemp: [],
      // 事件列表数据源
      eventList: [],
      // 添加事件窗口展示
      addEventVisible: false,
    };
  },
  computed: {
    // 当前展示的action列表
    actionList() {
      return this.eventList.filter((i) =>
        this.actions[this.eventConfigOn][this.eventConfigCondition].includes(i.id),
      );
    },
  },
  watch: {
    // 每次value更新都清空数据再重装 保证和value一致
    value(newValue) {
      Object.keys(this.actions).forEach((key) => {
        Object.keys(this.actions[key]).forEach((key2) => {
          this.actions[key][key2] = [];
        });
      });
      newValue.forEach((action) => {
        if (this.actions[action.on][action.condition]) {
          this.actions[action.on][action.condition].push(action.action_id);
        }
      });
    },
  },
  created() {
    this.$request({
      url: this.$api.getProcessActionList,
      data: {
        page: 0,
        size: -1,
      },
      cb: (res) => {
        this.eventList = res.list;
        this.value.forEach((action) => {
          if (this.actions[action.on][action.condition]) {
            this.actions[action.on][action.condition].push(action.action_id);
          }
        });
      },
    });
  },
  methods: {
    addEvent(eventList) {
      this.actions[this.eventConfigOn][this.eventConfigCondition] = eventList;
      this.$emit('update', this.getNewValue());
      this.addEventVisible = false;
    },
    deleteAction(id) {
      const index = this.actions[this.eventConfigOn][this.eventConfigCondition].findIndex(
        (i) => i === id,
      );
      this.actions[this.eventConfigOn][this.eventConfigCondition].splice(index, 1);
      this.$emit('update', this.getNewValue());
    },
    getNewValue() {
      const actionList = [];
      Object.keys(this.actions).forEach((key) => {
        Object.keys(this.actions[key]).forEach((key2) => {
          actionList.push(
            ...this.actions[key][key2].map((i) => {
              return {
                on: key,
                condition: key2,
                action_id: i,
              };
            }),
          );
        });
      });
      return actionList;
    },
  },
};
